// extracted by mini-css-extract-plugin
module.exports = {"activeCompanyRateCodeContainer":"ActiveCompanyRateCode_activeCompanyRateCodeContainer__fkC27","crossContainer":"ActiveCompanyRateCode_crossContainer___qZ0s"};